export function createBrainFrameState({ onChunk, onChip, onAsk, onUndo, onPreview } = {}) {
  return { buffer: '', text: '', onChunk, onChip, onAsk, onUndo, onPreview };
}

export function pushBrainFrames(state, chunk) {
  state.buffer += chunk;
  const lines = state.buffer.split('\n');
  state.buffer = lines.pop() || '';
  for (const line of lines) {
    applyBrainLine(state, line);
  }
}

export function flushBrainFrames(state) {
  if (state.buffer) applyBrainLine(state, state.buffer);
  state.buffer = '';
  return state.text;
}

function applyBrainLine(state, line) {
  const trimmed = String(line || '').trim();
  if (!trimmed) return;
  try {
    const event = JSON.parse(trimmed);
    if (event?.type === 'chip' && event.label) {
      state.onChip?.(event.label);
      return;
    }
    if (event?.type === 'ask' && event.question) {
      state.onAsk?.(event.question);
      return;
    }
    if (event?.type === 'undo') {
      state.onUndo?.(event);
      return;
    }
    if (event?.type === 'preview') {
      state.onPreview?.(event);
      return;
    }
    if (event?.type === 'text' && event.text) {
      state.text += event.text;
      state.onChunk?.(state.text);
      return;
    }
  } catch {
    /* raw leftover from an older door */
  }
  state.text += trimmed;
  state.onChunk?.(state.text);
}
